// removed by extract-text-webpack-plugin
module.exports = {"body":"_2BHf"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/AddToHome/AddToHomeModal/AddToHomeModal.scss
// module id = BM+4
// module chunks = 0